import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { getDistributorsOptions } from 'redux/distributors/selector';
import { getDistributors } from 'redux/distributors/selector';
import { getStatusNewProject } from 'redux/arqFinishes/newProject/selector';
import { getFasaraViewSheetImgSrc } from 'preview/sheetImageSrc';
import { fetchFasaraFilmByUuid } from '../../fetchFilmByUuid';

import PorletHeader, { PorletHeaderTitle } from 'components/porletHeader';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import '../step3/previewer.scss';

function hasUsableFilmDetail(fd) {
  if (!fd || typeof fd !== 'object') {
    return false;
  }
  return Boolean(
    fd.name ||
      fd.externalThumbnailUrl ||
      fd.external_thumbnail_url ||
      fd.externalImageUrl ||
      fd.external_image_url ||
      fd.externalImageURL,
  );
}

function pickFirstNonempty(...candidates) {
  for (let i = 0; i < candidates.length; i += 1) {
    const c = candidates[i];
    if (c != null && String(c).trim() !== '') {
      return String(c).trim();
    }
  }
  return '';
}

/** UUID payload, catalog row, or persisted `filmLabel` from step 3. */
function getFasaraFilmProductDisplayName(sheet, filmData) {
  if (filmData && typeof filmData === 'object') {
    const fromDetail = pickFirstNonempty(
      filmData.name,
      filmData.Name,
      filmData.label,
      filmData.Label,
      filmData.filmName,
      filmData.title,
      filmData.productName,
      get(filmData, 'type.name'),
    );
    if (fromDetail) {
      return fromDetail;
    }
  }
  return pickFirstNonempty(sheet.filmLabel, sheet.film);
}

function FasaraExpressSheetSummaryBlock({ sheet, distributorsOptions }) {
  const [fetchedFilm, setFetchedFilm] = useState(null);

  useEffect(() => {
    const uuid = sheet.filmUuid;
    if (!uuid || String(uuid).trim() === '' || sheet.film === 'Custom') {
      setFetchedFilm(null);
      return undefined;
    }
    if (hasUsableFilmDetail(sheet.filmData)) {
      setFetchedFilm(null);
      return undefined;
    }
    let cancelled = false;
    fetchFasaraFilmByUuid(uuid).then((detail) => {
      if (!cancelled) {
        setFetchedFilm(detail);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [sheet.filmUuid, sheet.film, sheet.filmData]);

  const filmData = fetchedFilm || sheet.filmData || null;
  const sheetForImg = { ...sheet, filmData };
  const productName = getFasaraFilmProductDisplayName(sheet, filmData);
  const warrantyText =
    filmData && filmData.warrantyYearsText
      ? String(filmData.warrantyYearsText)
      : '';

  return (
    <>
      <PorletHeaderTitle variant="h5">
        <FormattedMessage id="Aplicación:" />
      </PorletHeaderTitle>

      <div className="withmargin">
        <strong>
          <FormattedMessage id="Categoría:" />
        </strong>
        <span className="col-6">
          {sheet.glassFinishLabel ?? sheet.glassFinish}
        </span>
      </div>
      <div>
        <strong>
          <FormattedMessage id="Familia de Producto:" />
        </strong>
        <span className="col-6">{sheet.familyLabel ?? sheet.family}</span>
      </div>
      <div>
        <strong>
          <FormattedMessage id="Producto:" />
        </strong>
        <span className="col-6">{productName}</span>
      </div>
      {warrantyText ? (
        <div>
          <strong>
            <FormattedMessage id="Garantía" />
            {': '}
          </strong>
          <span className="col-6">{warrantyText}</span>
        </div>
      ) : null}
      {sheet.custom != '' ? (
        <div>
          <strong>
            <FormattedMessage id="Observación:" />
          </strong>
          <span className="col-6">{sheet.custom}</span>
        </div>
      ) : null}
      <div>
        <strong>
          <FormattedMessage id="M2 Necesarios:" />
        </strong>
        <span className="col-6">{sheet.meters}</span>
      </div>

      <div>
        <strong>
          <FormattedMessage id="Número de RUN:" />
        </strong>
        <span className="col-6">{sheet.run}</span>
      </div>

      <div>
        <strong>
          <FormattedMessage id="Distribuidor:" />
        </strong>
        <span className="col-6">
          {get(
            distributorsOptions.find(
              (item) => item.value === sheet.distributor,
            ),
            'label',
          )}
        </span>
      </div>
      <div>
        <strong>
          <FormattedMessage id="Vista Previa" />
        </strong>
        <img
          src={getFasaraViewSheetImgSrc(sheetForImg)}
          className="img-previewer-summary col-6"
          alt={productName}
        />
      </div>
    </>
  );
}

export const Step4 = ({
  distributorsOptions,
  values,
  prevStep,
  isLoading,
  hasError,
}) => (
  <>
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-2" />
      <div className="col-sm-12 col-md-12 col-lg-8">
        <PorletHeader>
          <PorletHeaderTitle variant="h4">
            <FormattedMessage id="Resumen del cliente" />
          </PorletHeaderTitle>
          <PorletHeaderTitle variant="h6">
            <FormattedMessage id="Por favor revisar todos los datos del proyecto." />
          </PorletHeaderTitle>
        </PorletHeader>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-2" />
    </div>
    <div className="kt-space-20" />
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-2" />
      <div className="col-sm-12 col-md-12 col-lg-8">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="row resumen">
              <div className="col-12">
                <div className="withmargin">
                  <PorletHeaderTitle variant="h5">
                    <FormattedMessage id="Cliente:" />
                  </PorletHeaderTitle>

                  <div>
                    <strong>
                      <FormattedMessage id="Nombre:" />
                    </strong>
                    <span>{values.contactName}</span>
                  </div>

                  <div>
                    <strong>
                      <FormattedMessage id="Email:" />
                    </strong>
                    <span>{values.email}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="kt-space-20" />
            <div className="row">
              <div className="col-12">
                <div className="withmargin">
                  <PorletHeaderTitle variant="h5">
                    <FormattedMessage id="Proyecto:" />
                  </PorletHeaderTitle>
                  <div>
                    <strong>
                      <FormattedMessage id="Nombre del proyecto:" />
                    </strong>
                    <span>{values.project.name}</span>
                  </div>
                  <div>
                    <strong>
                      <FormattedMessage id="Tipo de proyecto:" />
                    </strong>
                    <span>
                      <FormattedMessage id={values.project.type} />
                    </span>
                  </div>

                  <div>
                    <strong>
                      <FormattedMessage id="Código postal:" />
                    </strong>
                    <span>{values.project.postalCode}</span>
                  </div>

                  <div>
                    <strong>
                      <FormattedMessage id="Provincia:" />
                    </strong>
                    <span>{values.project.state}</span>
                  </div>
                  {values.installers.map((installer, index) => {
                    return (
                      <div key={index}>
                        <strong>
                          <FormattedMessage id="Instalador" /> {index + 1}:
                        </strong>
                        <span>{installer.name}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="kt-space-20" />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="row resumen">
              <div className="col-12">
                <div className="withmargin">
                  <div className="kt-space-20" />

                  <div className="kt-space-20" />
                  <PorletHeaderTitle variant="h6">
                    <FormattedMessage id="3M™ Architectural Finishes™" />
                  </PorletHeaderTitle>
                  <div className="kt-space-20" />
                  {values.fasaraSheets.map((fasaraSheet, index) => {
                    return (
                      <React.Fragment
                        key={`fasara-sheet-${index}-${fasaraSheet.film}-${
                          fasaraSheet.filmUuid || ''
                        }`}
                      >
                        <FasaraExpressSheetSummaryBlock
                          sheet={fasaraSheet}
                          distributorsOptions={distributorsOptions}
                        />
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="kt-space-20" />
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-2" />
    </div>
    <div className="kt-space-20" />
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-2" />
      <div className="col-sm-12 col-md-12 col-lg-8 ">
        <div>
          {hasError && (
            <Typography color="primary">
              <FormattedMessage id="Se a producido un error, vuelva a intentar" />
            </Typography>
          )}
        </div>
        <div className="submit-bottons">
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={isLoading}
          >
            <FormattedMessage id="Enviar la garantía a su cliente para validación" />
          </Button>
          <Button variant="outlined" onClick={prevStep} disabled={isLoading}>
            <FormattedMessage id="Editar" />
          </Button>
        </div>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-4"></div>
    </div>
  </>
);

export const mapStateToProps = (state) => ({
  distributorsOptions: getDistributorsOptions(state),
  fasaraFilmsBuildingOptions: [],
  distrbutorsList: getDistributors(state),
  ...getStatusNewProject(state),
});

export default connect(mapStateToProps)(Step4);
